import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from '../utils/EmblaCarouselArrowButtons';
import { addDotBtnsAndClickHandlers } from '../utils/EmblaCarouselDotButton';

export default (node) => {
  const init = () => {
    const emblaNode = node;

    const viewportNode = emblaNode.querySelector('.embla__viewport');
    const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
    const nextBtnNode = emblaNode.querySelector('.embla__button--next');
    const dotsNode = emblaNode.querySelector('.embla__dots');

    const options = { loop: false, slidesToScroll: 1, align: 'start' };
    const emblaApi = EmblaCarousel(viewportNode, options);

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      emblaApi,
      prevBtnNode,
      nextBtnNode
    );

    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
      emblaApi,
      dotsNode
    );
  };

  init();
};
